import { GET_LIST_PLACEPHONE } from '@/dataSource/api/PlacePhone/apiPlacePhone'
import { defineStore } from 'pinia'
import { ShowPerPage } from '../showPerPage/showPerPage'
import router from '@/router'
import { getIndexedDB, setIndexedDB } from '@/dataSource/indexed-DB/indexedDB'
import { removeCodeMobile } from '../RemoveCodeMobile'

interface TypeList {
    result: any
    dataList: any
    loading: Boolean
    emptyList: boolean
}
interface SearchType {
    dataSearch: any
    loadingSearch: Boolean
}

interface PageInt {
    numPage: number
    statusNextPage: Boolean
}
interface errMessage {
    errMessage: string
    showCardMessage: Boolean
}
interface successMessage {
    successMessage: string
    showCardMessage: Boolean
}
interface result {
    search: SearchType
    data: TypeList
    PageInt: PageInt
    err: errMessage
    success: successMessage
}
export const ListPlacePhone = defineStore('ListPlacePhone', {
    state: () => <result>({
        data: {
            result: [],
            dataList: [],
            loading: false,
            emptyList: false
        },
        search: {
            dataSearch: "",
            loadingSearch: false
        },
        PageInt: {
            numPage: 1,
            statusNextPage: false
        },
        err: {
            errMessage: '',
            showCardMessage: false
        },
        success: {
            successMessage: '',
            showCardMessage: false
        }
    }),
    actions: {
        // ofline
        async checkStatusUser() {
            if (window.navigator.onLine) {
                this.handelData()
            } else {
                this.data.loading = true
                this.handelOfflineList()
            }
        },
        async handelOfflineList() {
            this.data.loading = false

            this.data.dataList = await getIndexedDB('list-placephone')
            this.data.dataList = JSON.parse(this.data.dataList)

        },

        // pageInit
        async handelPageInt() {
            if (!this.PageInt.statusNextPage && this.data.result.data.placePhones.length == ShowPerPage) {
                if (window.innerHeight + window.pageYOffset + 200 >= document.body.offsetHeight) {
                    this.PageInt.numPage++
                    this.PageInt.statusNextPage = true
                    this.handelData(this.PageInt.numPage)
                }
            }

        },
        async handelClickEventPage(nameRoute: string, userID?: number) {
            if (window.navigator.onLine) {
                if (userID) {
                    router.push({ name: nameRoute, params: { id: userID } })
                } else {
                    router.push({ name: nameRoute })
                }
            } else {
                this.err.showCardMessage = true
                this.err.errMessage = 'شما آفلاین هستید .'
                setTimeout(() => {
                    this.err.showCardMessage = false
                    this.err.errMessage = ''
                }, 2000)
            }
        },

        async handelData(page?: any) {
            if (page) {
                this.data.result = await GET_LIST_PLACEPHONE(page)
            }
            else {
                this.data.loading = true
                this.data.result = await GET_LIST_PLACEPHONE()
            }
            this.handelList()
            this.checkEmptyList()
        },
        async handelList() {
            this.data.loading = false
            if (this.PageInt.statusNextPage && this.PageInt.numPage > 1) {
                this.data.dataList = this.data.dataList.concat(this.data.result.data.placePhones)
            } else {
                this.data.dataList = this.data.result.data.placePhones
                // this.data.dataList.forEach((item:any)=> {
                //     console.log(item);
                // });
            }
            await setIndexedDB('list-placephone', JSON.stringify(this.data.dataList))


            this.PageInt.statusNextPage = false
        },
        // search box 
        async handelSearchOffile(search?: string) {
            if (search) {
                this.data.dataList = await getIndexedDB('list-placephone')
                this.data.dataList = JSON.parse(this.data.dataList)

                this.data.dataList = this.data.dataList.filter((item: any) => {
                    // let mobile = removeCodeMobile(item.mobile)
                    Object.defineProperty(item, 'fullInfo', {
                        value: item.name + ' ' + item.phone
                    })
                    return item.fullInfo.search(search) != -1
                })


            } else {
                this.handelOfflineList()
            }
        },
        async handelSerachList(search: any) {
            this.data.loading = true
            this.PageInt.numPage = 1
            this.PageInt.statusNextPage = false
            this.data.result = await GET_LIST_PLACEPHONE(this.PageInt.numPage, search)
            this.handelSearch()
            this.checkEmptyList()
        },
        async handelSearch() {
            this.data.loading = false
            this.data.dataList = this.data.result.data.placePhones

        },

        async checkEmptyList() {
            if (this.data.dataList.length == 0) {
                this.data.emptyList = true
            } else {
                this.data.emptyList = false
            }
        }

    }
})